// src/utils/pdfPreviewUrl.js — doced-8f3a61c2 (Document editor, Stage 5f: Review & send's PDF tab)
//
// The PDF's bytes (getQuotePdf's pdfBase64) → an address that exists only in this browser, so the page can
// show the PDF in a frame or open it in a new tab. Nothing is stored and there is no link anyone else can use.
//
// A COPY of toBlobUrl in utils/pdfDownload.js (docpdf-8a4c1e73), which keeps it private; founder decision
// 2026-10-28: a small copy here rather than changing that file. pdfPreviewUrl.test.js lifts the original and
// fails if the two ever decode a PDF differently, so they can be merged into one at any time.
// The caller releases the address (URL.revokeObjectURL) when it is done with it.

export function pdfPreviewUrl(pdfBase64) {
    if (!pdfBase64) throw new Error('Could not make the PDF. Please try again.');
    const bin = atob(pdfBase64);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
}
